import defaultState from '../defaultState';

const defaultCurrentLocation = defaultState.currentLocation;
const defaultLocations = defaultState.locations;

export default function currentLocation(
  state = defaultCurrentLocation,
  action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_LOCATION':
      return {
        ...defaultCurrentLocation,
        ...action.location,
        settings: action.location.settings
      };

    case 'UPDATE_CURRENT_LOCATION_PERMISSIONS':
      return {
        ...state,
        permissions: action.permissions
      };

    case 'CLEAR_CURRENT_LOCATION':
      return defaultCurrentLocation;

    case 'CLEAR_LOCATIONS':
      return defaultLocations;

    case 'LOGOUT':
      return defaultCurrentLocation;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentLocation.js